import React from 'react';
import styles from '../NewLogin.module.scss';
import TokenForm from 'Pages/Auth/TwoStepAuthentication/components/TokenForm';

const VerificationCodeBlock: React.FC = () => {
	return (
		<div className={styles.contentBlock}>
			<h1 className={styles.title}>Enter your authentication code</h1>
			<p className={styles.authDescription}>
				For security, the Venza System uses multifactor authentication
				(MFA). Open your third-party authenticator application and type
				in the six-digit code displayed on your device.
			</p>
			<TokenForm />
			<p className={styles.footerText}>
				Can’t access your code? Contact your manager or System Admin for
				support.
			</p>
		</div>
	);
};

export default VerificationCodeBlock;
